import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { SessionService } from 'src/app/session-service.service';
import { BaseComponent } from '../BaseComponent';
import { QuestionOption } from '../../pages/GG/knowledge-test/knowledge-test';

@Component({
  selector: 'app-knowledge-test-select',
  templateUrl: './knowledge-test-select.component.html',
  styleUrls: ['./knowledge-test-select.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => KnowledgeTestSelectComponent),
    multi: true,
  }]
})
export class KnowledgeTestSelectComponent extends BaseComponent implements OnInit, ControlValueAccessor {
  @Input()
  selectOptions: Array<QuestionOption>;
  @Input()
  fontColor: string;
  @Input()
  fontSize: string;
  @Input()
  placeholderPrefix: string;
  @Input()
  disabled = false;

  controlType = this.constructor.name;
  private selectedValue: string;

  propagateChange = (value: string) => {};
  propagateTouch = () => {};

  constructor(
    translateService: TranslateService,
    sessionService: SessionService,
  ) {
    super(translateService, sessionService);
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();
    } catch (e) {
      console.error(
        `Failed initializing radio-input with placeholder ${this.placeholder}`
      );
    }
  }

  writeValue(value: string): void {
    this.selectedValue = value;
  }

  get getSelectedValue(): string {
    return this.selectedValue;
  }

  set setSelectedValue(value) {
    this.selectedValue = value;
    this.propagateChange(value);
    this.propagateTouch();
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  selectOption(option: QuestionOption): void {
    if (this.disabled) {
      return;
    }
    this.selectedValue = option.value;
    this.propagateChange(option.value);
    this.propagateTouch();
  }
}
